import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, TS_AppTools, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './ATS_Input.scss';
export class ATS_Input extends ComponentSync {
    static Screen = {
        name: 'Input',
        key: 'input',
        group: 'Components',
        renderer: this,
    };
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('Inputs Test'), _jsx(LL_V_L, { className: 'ats-inputs', children: _jsx(TS_PropRenderer.Vertical, { label: 'Regular', children: _jsx(TS_Input, { type: 'text', placeholder: 'Placeholder' }) }) })] });
    }
}
//# sourceMappingURL=ATS_Input.js.map